
import { Component, Prop, Vue } from 'vue-property-decorator';
import type { Project } from '@/models/project';
import XProcessWorksheet from '@/components/projects/fields/XProcessWorksheet.vue';

@Component({
    name: 'ProjectViewXGrid',
    components: {
        XProcessWorksheet,
    },
})
export default class ProjectViewXGrid extends Vue {
    @Prop({
        required: true,
    })
    private project: Project;
}
